import { render, staticRenderFns } from "./mHomeText.vue?vue&type=template&id=19b81a07&"
import script from "./mHomeText.vue?vue&type=script&lang=js&"
export * from "./mHomeText.vue?vue&type=script&lang=js&"
import style0 from "./mHomeText.vue?vue&type=style&index=0&id=19b81a07&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports